module.exports = __webpack_public_path__ + "img/dashboard_welcome.a82d9957.gif";